import { Edit } from "@mui/icons-material"
import { IconButton } from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import { useNavigate } from 'react-router-dom'

export function DefaultColumnActions({ row, routeForm, onDelete, showEdit = true, showDelete = true }) {
    const navigate = useNavigate()

    const editObj = () => {
        navigate(`/${routeForm}?uid=${row.uid}`);
    }

    const deleteObj = () => {
        if (onDelete) {
            onDelete(row)
        }
    }

    return (
        <div style={{ display: "flex", justifyContent: "start", height: "100%" }}>
            {showEdit && (
                <IconButton size="small" onClick={editObj}>
                    <Edit />
                </IconButton>
            )}
            {showDelete && (
                <IconButton size="small" onClick={deleteObj}>
                    <DeleteIcon />
                </IconButton>
            )}
        </div>
    )
}
